'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = require('@vx/event');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Drag = function (_React$Component) {
  _inherits(Drag, _React$Component);

  function Drag(props) {
    _classCallCheck(this, Drag);

    var _this = _possibleConstructorReturn(this, (Drag.__proto__ || Object.getPrototypeOf(Drag)).call(this, props));

    _this.state = {
      x: undefined,
      y: undefined,
      dx: 0,
      dy: 0,
      isDragging: false
    };
    _this.dragEnd = _this.dragEnd.bind(_this);
    _this.dragMove = _this.dragMove.bind(_this);
    _this.dragStart = _this.dragStart.bind(_this);
    return _this;
  }

  _createClass(Drag, [{
    key: 'dragStart',
    value: function dragStart(event) {
      var _props = this.props,
          onDragStart = _props.onDragStart,
          resetOnStart = _props.resetOnStart;
      var _state = this.state,
          dx = _state.dx,
          dy = _state.dy;
      var point = (0, _event.localPoint)(event);

      var nextState = _extends({}, this.state, {
        isDragging: true,
        dx: resetOnStart ? 0 : dx,
        dy: resetOnStart ? 0 : dy,
        x: resetOnStart ? point.x : -dx + point.x,
        y: resetOnStart ? point.y : -dy + point.y
      });

      if (onDragStart) onDragStart(_extends({}, nextState, {
        event: event
      }));
      this.setState(function () {
        return nextState;
      });
    }
  }, {
    key: 'dragMove',
    value: function dragMove(event) {
      var onDragMove = this.props.onDragMove;
      var _state2 = this.state,
          x = _state2.x,
          y = _state2.y,
          isDragging = _state2.isDragging;
      if (!isDragging) return;
      var point = (0, _event.localPoint)(event);

      var nextState = _extends({}, this.state, {
        isDragging: true,
        dx: -(x - point.x),
        dy: -(y - point.y)
      });

      if (onDragMove) onDragMove(_extends({}, nextState, {
        event: event
      }));
      this.setState(function () {
        return nextState;
      });
    }
  }, {
    key: 'dragEnd',
    value: function dragEnd(event) {
      var onDragEnd = this.props.onDragEnd;
      var point = (0, _event.localPoint)(event);

      var nextState = _extends({}, this.state, {
        isDragging: false
      });

      if (onDragEnd) onDragEnd(_extends({}, nextState, {
        event: event
      }));
      this.setState(function () {
        return nextState;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state3 = this.state,
          x = _state3.x,
          y = _state3.y,
          dx = _state3.dx,
          dy = _state3.dy,
          isDragging = _state3.isDragging;
      var _props2 = this.props,
          children = _props2.children,
          width = _props2.width,
          height = _props2.height,
          captureDragArea = _props2.captureDragArea;
      return _react2.default.createElement('g', null, isDragging && captureDragArea && _react2.default.createElement('rect', {
        width: width,
        height: height,
        onMouseMove: this.dragMove,
        onMouseUp: this.dragEnd,
        fill: 'transparent'
      }), children({
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        isDragging: isDragging,
        dragEnd: this.dragEnd,
        dragMove: this.dragMove,
        dragStart: this.dragStart
      }));
    }
  }]);

  return Drag;
}(_react2.default.Component);

Drag.propTypes = {
  children: _propTypes2.default.func.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  captureDragArea: _propTypes2.default.bool,
  resetOnStart: _propTypes2.default.bool
};
Drag.defaultProps = {
  captureDragArea: true,
  resetOnStart: false
};
exports.default = Drag;